var map = {
	"./coin/anim/in/coin_in_000.png": 1875,
	"./coin/anim/in/coin_in_001.png": 1876,
	"./coin/anim/in/coin_in_002.png": 1877,
	"./coin/anim/in/coin_in_003.png": 1878,
	"./coin/anim/in/coin_in_004.png": 1879,
	"./coin/anim/in/coin_in_005.png": 1880,
	"./coin/anim/in/coin_in_006.png": 1881,
	"./coin/anim/in/coin_in_007.png": 1882,
	"./coin/anim/in/coin_in_008.png": 1883,
	"./coin/anim/in/coin_in_009.png": 1884,
	"./coin/anim/in/coin_in_010.png": 1885,
	"./coin/anim/in/coin_in_011.png": 1886,
	"./coin/anim/in/coin_in_012.png": 1887,
	"./coin/anim/in/coin_in_013.png": 1888,
	"./coin/anim/in/coin_in_014.png": 1889,
	"./coin/anim/in/coin_in_015.png": 1890,
	"./coin/anim/in/coin_in_016.png": 1891,
	"./coin/anim/in/coin_in_017.png": 1892,
	"./coin/anim/in/coin_in_018.png": 1893,
	"./coin/anim/in/coin_in_019.png": 1894,
	"./coin/anim/in/coin_in_020.png": 1895,
	"./coin/anim/in/coin_in_021.png": 1896,
	"./coin/anim/in/coin_in_022.png": 1897,
	"./coin/anim/in/coin_in_023.png": 1898,
	"./coin/anim/in/coin_in_024.png": 1899,
	"./coin/anim/in/coin_in_025.png": 1900,
	"./coin/anim/out_1/out_1_000.png": 1901,
	"./coin/anim/out_1/out_1_001.png": 1902,
	"./coin/anim/out_1/out_1_002.png": 1903,
	"./coin/anim/out_1/out_1_003.png": 1904,
	"./coin/anim/out_1/out_1_004.png": 1905,
	"./coin/anim/out_1/out_1_005.png": 1906,
	"./coin/anim/out_1/out_1_006.png": 1907,
	"./coin/anim/out_1/out_1_007.png": 1908,
	"./coin/anim/out_1/out_1_008.png": 1909,
	"./coin/anim/out_1/out_1_009.png": 1910,
	"./coin/anim/out_2/out_2_000.png": 1911,
	"./coin/anim/out_2/out_2_001.png": 1912,
	"./coin/anim/out_2/out_2_002.png": 1913,
	"./coin/anim/out_2/out_2_003.png": 1914,
	"./coin/anim/out_2/out_2_004.png": 1915,
	"./coin/anim/out_2/out_2_005.png": 1916,
	"./coin/anim/out_2/out_2_006.png": 1917,
	"./coin/anim/out_2/out_2_007.png": 1918,
	"./coin/anim/out_2/out_2_008.png": 1919,
	"./coin/anim/out_2/out_2_009.png": 1920,
	"./coin/anim/shine_1/shine_1_000.png": 1921,
	"./coin/anim/shine_1/shine_1_001.png": 1922,
	"./coin/anim/shine_1/shine_1_002.png": 1923,
	"./coin/anim/shine_1/shine_1_003.png": 1924,
	"./coin/anim/shine_1/shine_1_004.png": 1925,
	"./coin/anim/shine_1/shine_1_005.png": 1926,
	"./coin/anim/shine_1/shine_1_006.png": 1927,
	"./coin/anim/shine_1/shine_1_007.png": 1928,
	"./coin/anim/shine_1/shine_1_008.png": 1929,
	"./coin/anim/shine_1/shine_1_009.png": 1930,
	"./coin/anim/shine_1/shine_1_010.png": 1931,
	"./coin/anim/shine_1/shine_1_011.png": 1932,
	"./coin/anim/shine_1/shine_1_012.png": 1933,
	"./coin/anim/shine_1/shine_1_013.png": 1934,
	"./coin/anim/shine_1/shine_1_014.png": 1935,
	"./coin/anim/shine_1/shine_1_015.png": 1936,
	"./coin/anim/shine_1/shine_1_016.png": 1937,
	"./coin/anim/shine_1/shine_1_017.png": 1938,
	"./coin/anim/shine_1/shine_1_018.png": 1939,
	"./coin/anim/shine_1/shine_1_019.png": 1940,
	"./coin/anim/shine_1/shine_1_020.png": 1941,
	"./coin/anim/shine_1/shine_1_021.png": 1942,
	"./coin/anim/shine_1/shine_1_022.png": 1943,
	"./coin/anim/shine_1/shine_1_023.png": 1944,
	"./coin/anim/shine_1/shine_1_024.png": 1945,
	"./coin/anim/shine_1/shine_1_025.png": 1946,
	"./coin/anim/shine_1/shine_1_026.png": 1947,
	"./coin/anim/shine_1/shine_1_027.png": 1948,
	"./coin/anim/shine_1/shine_1_028.png": 1949,
	"./coin/anim/shine_1/shine_1_029.png": 1950,
	"./coin/anim/shine_1/shine_1_030.png": 1951,
	"./coin/anim/shine_2/shine_2_000.png": 1952,
	"./coin/anim/shine_2/shine_2_001.png": 1953,
	"./coin/anim/shine_2/shine_2_002.png": 1954,
	"./coin/anim/shine_2/shine_2_003.png": 1955,
	"./coin/anim/shine_2/shine_2_004.png": 1956,
	"./coin/anim/shine_2/shine_2_005.png": 1957,
	"./coin/anim/shine_2/shine_2_006.png": 1958,
	"./coin/anim/shine_2/shine_2_007.png": 1959,
	"./coin/anim/shine_2/shine_2_008.png": 1960,
	"./coin/anim/shine_2/shine_2_009.png": 1961,
	"./coin/anim/shine_2/shine_2_010.png": 1962,
	"./coin/anim/shine_2/shine_2_011.png": 1963,
	"./coin/anim/shine_2/shine_2_012.png": 1964,
	"./coin/anim/shine_2/shine_2_013.png": 1965,
	"./coin/anim/shine_2/shine_2_014.png": 1966,
	"./coin/anim/shine_2/shine_2_015.png": 1967,
	"./coin/anim/shine_2/shine_2_016.png": 1968,
	"./coin/anim/shine_2/shine_2_017.png": 1969,
	"./coin/anim/shine_2/shine_2_018.png": 1970,
	"./coin/anim/shine_2/shine_2_019.png": 1971,
	"./coin/anim/shine_2/shine_2_020.png": 1972,
	"./coin/anim/shine_2/shine_2_021.png": 1973,
	"./coin/anim/shine_2/shine_2_022.png": 1974,
	"./coin/anim/shine_2/shine_2_023.png": 1975,
	"./coin/anim/shine_2/shine_2_024.png": 1976,
	"./coin/anim/shine_2/shine_2_025.png": 1977,
	"./coin/anim/shine_2/shine_2_026.png": 1978,
	"./coin/anim/shine_2/shine_2_027.png": 1979,
	"./coin/anim/shine_2/shine_2_028.png": 1980,
	"./coin/anim/shine_2/shine_2_029.png": 1981,
	"./coin/anim/shine_2/shine_2_030.png": 1982,
	"./coin/coin_dice_1.png": 1983,
	"./coin/coin_dice_2.png": 1984,
	"./coin/coin_start_1.png": 1985,
	"./coin/coin_start_2.png": 1986,
	"./coin_start_1.png": 1987,
	"./coin_start_2.png": 1988,
	"./header-babaijebu.png": 341,
	"./one.svg": 1989,
	"./two.svg": 1990
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1874;


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img \.(gif|png|jpe?g|svg)$/
// module id = 1874
// module chunks = 4